import { distructAndDispatch } from '@core/utils/methods/destruct-and-dispatch';
import {
  LeasingDetails,
  LeasingLeaseAuditTabData,
  LeasingSummaryTabData,
  ProjectFuzeID,
  ProjectPaceTask,
  RadData,
} from '@models/interfaces';
import { ProjectActions } from '../actions/project.actions';
import { ProjectFuzeIDsActions } from '../actions/project-fuze-ids.actions';
// eslint-disable-next-line no-restricted-imports
import store from '../index';

export namespace LeasingEffects {
  export const setPACETasksTableDataFromDetails = distructAndDispatch<
    LeasingDetails,
    ProjectPaceTask[]
  >('PACETasksTableData', ProjectActions.updateProjectPaceTasksAction);

  export const setPACETasksFromDetails = distructAndDispatch<
    LeasingDetails,
    ProjectPaceTask[]
  >('PACETasks', ProjectActions.updateProjectPaceTaskFields);

  export const setProjectFuzeIDsFromDetails = distructAndDispatch<
    LeasingDetails,
    ProjectFuzeID[]
  >('categories', ProjectFuzeIDsActions.setProjectFuzeIDsAction);

  export const setRAD = distructAndDispatch<LeasingDetails, RadData[]>(
    'RAD',
    ProjectActions.setRADAction,
  );

  export const setCurrentProvidenceAgent = distructAndDispatch<
    LeasingDetails,
    string
  >('providenceAgentName', ProjectActions.setCurrentProvidenceAgentAsString);

  export const setHoldOptions = (leasing: LeasingDetails) => {
    store.dispatch(ProjectActions.setHoldOptionsByLeasing.done(leasing));

    return leasing;
  };

  export const handleLeasingSummary = (
    response: LeasingSummaryTabData,
  ): void => {
    if (response.categories) {
      store.dispatch(
        ProjectFuzeIDsActions.setProjectFuzeIDsAction.done(response.categories),
      );
    }

    if (response.PACETasksTableData) {
      store.dispatch(
        ProjectActions.updateProjectPaceTasksAction.done(
          response.PACETasksTableData,
        ),
      );
    }

    if (response.PACETasks) {
      store.dispatch(
        ProjectActions.updateProjectPaceTaskFields.done(response.PACETasks),
      );
    }

    if (response.providenceAgentName) {
      store.dispatch(
        ProjectActions.setCurrentProvidenceAgentAsString.done(
          response.providenceAgentName,
        ),
      );
    }
  };

  export const handleLeasingLeaseAudit = (
    response: LeasingLeaseAuditTabData,
  ): void => {
    if (response.RAD) {
      store.dispatch(ProjectActions.setRADAction.done(response.RAD));
    }
  };
}
